var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.54102 10.001C3.54102 6.15737 6.65688 3.0415 10.5005 3.0415C14.3441 3.0415 17.46 6.15737 17.46 10.001C17.46 13.8446 14.3441 16.9605 10.5005 16.9605C6.65688 16.9605 3.54102 13.8446 3.54102 10.001ZM10.5005 1.5415C5.82845 1.5415 2.04102 5.32894 2.04102 10.001C2.04102 14.673 5.82845 18.4605 10.5005 18.4605C15.1725 18.4605 18.96 14.673 18.96 10.001C18.96 5.32894 15.1725 1.5415 10.5005 1.5415ZM9.78409 6.37053C9.45995 6.6961 9.46064 7.22273 9.78576 7.54745C10.1111 7.87236 10.6381 7.8722 10.9633 7.54708C11.2884 7.22197 11.2885 6.6949 10.9636 6.36959C10.6387 6.04427 10.1117 6.04378 9.78613 6.36848L9.78521 6.3694L9.78409 6.37053ZM8.96248 9.39228C8.96248 9.0471 9.24231 8.76728 9.58748 8.76728H10.5004C10.8456 8.76728 11.1254 9.0471 11.1254 9.39228V12.2163H11.4134C11.7586 12.2163 12.0384 12.4961 12.0384 12.8413C12.0384 13.1864 11.7586 13.4663 11.4134 13.4663H10.5004C10.1553 13.4663 9.87545 13.1864 9.87545 12.8413V10.0173H9.58748C9.24231 10.0173 8.96248 9.73746 8.96248 9.39228Z",
    fill: "#ADABC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b2f1886c8103bcddda21ce4578857cd1.svg";
export { ForwardRef as ReactComponent };